import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageSectionItem from "./common/ImageSectionItem"
import ImageTitleItem from "./common/ImageTitleItem"
import SeparatorLine from "./common/SeparatorLine"
import "./Publish.css"
import { useEffect } from "react"

const Publish = () => {

    useEffect(() => {
        document.title = 'Séneca - Publicaciones'
        window.scrollTo(0, 0)
    }, [])

    return (
        <main className="publish-main">

            <ImageTitleItem
                imageURL="/images/publish/publicacion-1.jpg"
                overImageURL="/images/publish/publicacion-1b.png"
                titleText="Publicación"
                icon="bi bi-diagram-3-fill blue-icon"
                subtitleText="Séneca es un gestor de contenido multimedia que permite a los usuarios del sistema, internos o públicos, facilidades para buscar, acceder, compartir y difundir información"
            />
            <SliderImageSeparator />
            <ImageSectionItem
                imageURL="/images/publish/publicacion-2.jpg"
                imagePosition="before"
                layout="row"
                title="Streaming"
                textArray={["<p class='middle-section-label'><strong>Séneca permite realizar una transmisión multicanal en directo de las sesiones o eventos que se realicen de manera simultánea, mediante streaming adaptativo y mutiplataforma.</strong></p>", "<p class='middle-section-label'>Utiliza formatos HTML5 para la compatibilidad de navegadores en móviles, PC's y entornos Mac, y dispone de Apps completas para dispositivos móviles, tanto IOS como Android.</p>"]}
            modern="true"
            />
            <SeparatorLine />
            <ImageSectionItem
                imageURL="/images/publish/publicacion-1b.png"
                imagePosition="after"
                layout="row"
                title="Videoteca"
                textArray={["<p class='middle-section-label'>Un portal dinámico, organizado y ágil con formato de medio de comunicación. Acceso a grabaciones destacadas y recientes, personalización de la información por usuario, y, lo más importante, un buscador inteligente a través del contenido de los vídeos.</p>"]}
            modern="true"
            />
            <SeparatorLine />
            <ImageSectionItem
                imageURL="/images/publish/publicacion-3.jpg"
                imagePosition="before"
                layout="row"
                title="Acceda a los oradores"
                textArray={["<p class='middle-section-label'>Puede acceder a las intervenciones desde la ficha de los oradores, infórmese de sus contenidos, agréguelos a sus favoritos y la próxima vez que abra Séneca, el sistema le presentará sus últimas participaciones en debates o le enviará una notificación con un link cada vez que intervenga.</p>"]}
            modern="true"
            />
            <SeparatorLine />
            <ImageSectionItem
                imageURL="/images/publish/publicacion-4.jpg"
                imagePosition="after"
                layout="row"
                title="Busque por palabras pronunciadas en el vídeo (SpeechToText)"
                textArray={["<p class='middle-section-label'>Séneca dispone de un proceso de extracción de texto del vídeo, que lo indexa junto al mismo y permite realizar búsquedas en los discursos. Combine el texto con el filtro de oradores y podrá comparar las opiniones de dos personas sobre el mismo tema.</p>"]}
            modern="true"
            />

            <SeparatorLine />
            <ImageSectionItem
                imageURL="/images/publish/publicacion-5.jpg"
                imagePosition="before"
                layout="row"
                title="Catálogo multimedia y Actas"
                textArray={["<p class='middle-section-label'>Obtenga material gráfico, textos, diarios de sesiones, boletines o cualquier contenido vinculado a la sesión, localizándolos a través de un completo catálogo multimedia.</p>", "<p class='middle-section-label'>El secretario puede firmar el vídeo mediante DNI-e o certificado personal y vincularlo al Acta de acuerdos en un documento PDF.</p>"]}
            modern="true"
            />

            <SeparatorLine />
            <ImageSectionItem
                imageURL="/images/publish/publicacion-6.jpg"
                imagePosition="after"
                layout="row"
                title="Catálogo múltiple"
                textArray={["<p class='middle-section-label'>Séneca no sólo contempla las categorías legislativas (Legislaturas, Órganos, Sesiones, Iniciativas y P.O.D., Intervenciones, Votaciones y Comentarios), sino que permite gestionar otros contenidos como eventos, ruedas de prensa, presentaciones o actos patrocinados por la institución. También pueden añadirse etiquetas libres a los contenidos y utilizarlas como criterio de búsqueda. El catálogo facilita la creación de canales específicos para estos eventos y su presentación en la web.</p>"]}
            modern="true"
            />

            <SeparatorLine />
            <ImageSectionItem
                imageURL="/images/publish/publicacion-7.jpg"
                imagePosition="before"
                layout="row"
                title="Web semántica: Linked Data"
                textArray={["<p class='middle-section-label'>Séneca dispone de una completa API para desarrolladores que permite su integración con otras plataformas. Como innovación, posee un nodo completo de publicación en formato Linked Data que lo hace accesible desde los más prestigiosos buscadores y agregadores de contenido. Esta funcionalidad permite el análisis cruzado de información entre los contenidos compartidos y los comentarios en redes sociales.</p>"]}
            modern="true"
            />

        </main>
    )

}

export default Publish